import React from 'react'
import useHover from '../_custom-hooks/useHover'

const ToolTip = ({text, right, width}) => {
    const [hoverRef, isHovered] = useHover()
    const marginLeft = right ? '-170px' : '-30px'
    return(
        <span style={isHovered ? {...styles.icon, opacity: '1'} : styles.icon}
        >
            
            <span style={styles.help} ref={hoverRef} >?</span>
            <span style={isHovered? {...styles.tooltip, visibility: 'visible', marginLeft, width: width || '200px'} : {...styles.tooltip, marginLeft, width: width || '200px'}}>
                {text.map((t, i) => (
                    <div key={t}>
                        {i > 0 && (
                            <>
                            <br />
                            </>
                        )}
                        {t}
                    </div>
                ))}
            </span>
        </span>
    )
}

const styles = {
    icon: {
        // margin:'.5rem',
        // marginBottom: "1rem",
        color: "red",
        position: "relative",
        display: "inline-block",
        opacity: ".5"
    },
    tooltip: {
        visibility: "hidden",
        backgroundColor: "#22356E",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        borderRadius: "6px",
        position: "absolute",
        zIndex: "1",
        fontSize: "0.6rem",
        opacity: "0.8",
        marginTop: "15px",
        border: "1px solid grey"
    },
    help: {
        display: "block",
        background: "#D61F36",
        color: "#fff",
        borderRadius: "50%",
        width: "15px",
        height: "15px",
        lineHeight: "15px",
        textAlign: "center",
        fontSize: "10px",
        fontFamily: "verdana"
    }
}
export default ToolTip